import React from 'react';
import { defaultTemplate } from 'core/hoc';

function ErrorBoundaryTemplate({ error, info, t }) {
	return <h1>{t('ERRORMISC')}</h1>;
}

export default defaultTemplate(ErrorBoundaryTemplate);
